<template>
  <transition-expand>
    <div
      class="mt-4 w-full overflow-scroll"
      @touchstart.capture="onPress"
      @mousedown.capture="onPress"
      @mouseup.capture="onPressup"
      @blur.capture="onPressup"
    >
      <div class="bg-white overflow-scroll">
        <slot></slot>
      </div>
    </div>
  </transition-expand>
</template>

<script>
import TransitionExpand from '@/components/TransitionExpand'
export default {
  name: 'ReportTable',
  components: {
    TransitionExpand
  },
  methods: {
    onPress() {
      this.$store.dispatch('config/setDragLock', true)
      setTimeout(() => {
        this.$store.dispatch('config/setDragLock', false)
      }, 1000)
    },
    onPressup() {
      this.$store.dispatch('config/setDragLock', false)
    },
    touch() {
      this.$store.dispatch('config/setDragLock', true)
    }
  }
}
</script>
